export default {
  "site.name": "Itaobuy Spreadsheet Italia",
  "site.tagline": "La guida italiana completa per lo shopping internazionale",
  "nav.home": "Home",
  "nav.database": "Database",
  "nav.guide": "Guide",
  "nav.community": "Community",
  "nav.category": "Seleziona Categoria",
  "hero.title1": "Itaobuy",
  "hero.title2": "Spreadsheet Italia",
  "hero.subtitle": "La piattaforma più completa per scoprire, confrontare e acquistare prodotti dai migliori marketplace internazionali. Guide dettagliate, database aggiornato e consigli esperti per uno shopping sicuro e conveniente.",
  "hero.cta1": "itaobuy sheet",
  "hero.cta2": "buy it now",
  "categories.label": "Categorie Prodotti",
  "categories.title1": "Esplora le Categorie",
  "categories.title2": "Itaobuy Sheet",
  "categories.subtitle": "Sfoglia le nostre categorie curate per trovare esattamente ciò che cerchi. Ogni categoria ti porta direttamente ai migliori prodotti selezionati.",
  "categories.view_all": "Vedi tutti",
  "guide.title": "Guide & Database",
  "guide.subtitle": "Aggiornati 2026",
  "guide.desc": "Risorse complete per navigare il mondo Itaobuy Spreadsheet con sicurezza. Guide passo-passo, analisi dei prodotti e consigli pratici per ogni tipo di acquirente.",
  "guide.card1.title": "Guida Completa Itaobuy Sheet",
  "guide.card1.desc": "Tutto quello che devi sapere sullo spreadsheet Itaobuy: come funziona, come usarlo e perché è lo strumento essenziale per lo shopping internazionale.",
  "guide.card1.btn": "Leggi la Guida",
  "guide.card2.title": "Database Prodotti",
  "guide.card2.desc": "Esplora il nostro database completo di prodotti verificati con prezzi, valutazioni di qualità e aggiornamenti in tempo reale.",
  "guide.card2.btn": "Esplora Database",
  "guide.card3.title": "Sicurezza & Trust",
  "guide.card3.desc": "Guida alla sicurezza: come riconoscere venditori affidabili, proteggere i tuoi dati e fare acquisti in totale tranquillità.",
  "guide.card3.btn": "Centro Sicurezza",
  "cta.title": "Accedi allo Spreadsheet Completo",
  "cta.subtitle": "Unisciti a migliaia di acquirenti italiani che già utilizzano Itaobuy Spreadsheet per trovare i migliori prodotti ai prezzi più competitivi.",
  "cta.btn": "Vai allo Spreadsheet",
  "community.label": "Community",
  "community.title1": "Cosa Dicono di Noi",
  "community.title2": "",
  "community.subtitle": "Recensioni autentiche dalla nostra community di acquirenti italiani che utilizzano Itaobuy Spreadsheet ogni giorno.",
  "about.label": "Chi Siamo",
  "about.title1": "Il modo più",
  "about.title2": "semplice per",
  "about.title3": "comprare nel mondo",
  "about.desc": "Itaobuy Spreadsheet Italia è nato con una missione chiara: aiutare gli utenti italiani a comprendere e utilizzare al meglio Itaobuy Spreadsheet attraverso guide, analisi e risorse sempre aggiornate. Il nostro team di esperti analizza costantemente il mercato per offrirti le informazioni più affidabili.",
  "footer.tagline": "La tua guida italiana definitiva per lo shopping internazionale con Itaobuy Spreadsheet.",
  "footer.products": "Prodotti",
  "footer.guides": "Guide",
  "footer.safety": "Sicurezza",
  "footer.community": "Community",
  "footer.copyright": "© 2026 Itaobuy Spreadsheet Italia. Tutti i diritti riservati.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Termini di Servizio",
  "trust.item1": "Aggiornamenti frequenti",
  "trust.item2": "Guide in italiano",
  "trust.item3": "Analisi indipendente",
  "trust.item4": "Struttura sicura",
  "article.read_time": "Tempo di lettura",
  "article.minutes": "minuti",
  "article.updated": "Ultimo aggiornamento",
  "article.author": "Autore",
  "article.author_name": "Esperto Itaobuy Spreadsheet",
  "article.author_bio": "Analista esperto del mercato internazionale con oltre 5 anni di esperienza nello shopping cross-border. Specializzato in Itaobuy Spreadsheet e nell'ottimizzazione degli acquisti online.",
  "article.back_home": "← Torna alla Home",
  "article.cta": "Accedi allo Spreadsheet Completo",
}